// @flow

import React from 'react';
import PersonIcon from '@mui/icons-material/Person';

export default {
  withDrawer: true,
  drawerProps: {
    navigations: [
      {
        links: [{ to: '/profile', icon: <PersonIcon />, label: 'Profile' }]
      }
    ]
  }
};
